import * as Yup from 'yup';

export const ChangeAdressDataValidation = Yup.object({
  cep: Yup.string().min(9, 'Insira um CEP válido').required('CEP deve ser preenchido'),
  numero: Yup.string().required('Número deve ser preenchido')
});